import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { GameVars } from "../../../GameVars";
import { Card } from "../cards/Card";
import { GameManager } from "../../../GameManager";
import { GameConstants } from "../../../GameConstants";

export class NextCardContainer extends Phaser.GameObjects.Container {

    private static readonly SCALE = .7;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const lan = GameVars.gameData.language;
        const text = GameVars.currentScene.cache.json.get("text");

        this.x = 685 + 300;
        this.y = GameConstants.GAME_HEIGHT - 125 * GameVars.scaleY;
        this.scaleY = GameVars.scaleY;
       
        // ENCONTRAR EL INDICE DE LA ÚLTIMA CARTA DESBLOQUEADA
        const specialCards = GameVars.gameData.specialCards;

        let lastUnlockedCardIndex = 0;

        for (let i = 0; i < specialCards.length; i++) {

            if (!specialCards[i].unlocked) {
                lastUnlockedCardIndex = i;
                break;
            }
        }

        if (lastUnlockedCardIndex !== 0) {

            const rotatedContainer = new Phaser.GameObjects.Container(this.scene);
            rotatedContainer.scaleX = NextCardContainer.SCALE;
            rotatedContainer.scaleY = NextCardContainer.SCALE;
            rotatedContainer.angle = 35;
            this.add(rotatedContainer);
            
            const background = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "card_description_background");
            background.setScale(.6, 3.12);
            rotatedContainer.add(background);

            const nextCardLabel = new Phaser.GameObjects.Text (this.scene, 0, -145, text.NEXT_CARD[lan], { fontFamily: "AlmendraBold", fontSize: "36px", color: "#000000" });
            nextCardLabel.setShadow(0, 4, "#7e4031", 0, false, true);
            nextCardLabel.setStroke("#3f2620", 6);
            nextCardLabel.setOrigin(.5);
            rotatedContainer.add(nextCardLabel);

            if (nextCardLabel.width > 195) {
                nextCardLabel.scale = 195 / nextCardLabel.width;
            }
        
            const gradient = nextCardLabel.context.createLinearGradient(0, 0, 0, nextCardLabel.height);
            gradient.addColorStop(0, "#fffea8");
            gradient.addColorStop(0.5, "#feec57");
            gradient.addColorStop(1, "#ef8548");
            nextCardLabel.setFill(gradient);

            const p = {x: 0, y: 0, angle: 0};
            const cardData: CardCrawl.CardData = {
                id: null,
                type: specialCards[lastUnlockedCardIndex].type,
                value: specialCards[lastUnlockedCardIndex].type === CardCrawl.CardType.LASH ? 3 : null,
                lastValue: specialCards[lastUnlockedCardIndex].type === CardCrawl.CardType.LASH ? 3 : null,
                special: true,
                allowedMoves: { upperTableau: [false, false, false, false], lowerTableau: [false, false, false, false], chest: false},
                uiData: {                      
                    spawned: false,
                    spawningIndex: null,
                    openingSpawn: null,
                    performedAction: null,
                    receivedDamage: null,
                    delay: null
                }  
            };

            const card = new Card(this.scene, p, cardData);
            rotatedContainer.add(card);

            const cardPriceLabel = new Phaser.GameObjects.Text(this.scene, 40, 142, GameVars.formatNumber(specialCards[lastUnlockedCardIndex].price), { fontFamily: "AlmendraBold", fontSize: "38px", color: "#663227" });
            cardPriceLabel.setOrigin(1, .5)
            rotatedContainer.add(cardPriceLabel);

            const coinIcon = new Phaser.GameObjects.Image(this.scene, cardPriceLabel.x + 25, cardPriceLabel.y, "texture_atlas_1", "coin");
            rotatedContainer.add(coinIcon);

            this.scene.tweens.add({
                targets: this,
                x: 685,
                duration: 500,
                delay: 3500,
                ease: Phaser.Math.Easing.Cubic.Out
            });

            this.scene.tweens.add({
                targets: rotatedContainer,
                angle: 5,
                duration: 500,
                delay: 3000,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }
    }
}